import { OPEN_CUSTOMS_AND_CROSSING } from '@/features/shared/helpers/typologies';

export type FolderTypology = {
  folderTypologyId: string;
  descriptionTranslationKey: string;
};

export type FolderTypologyResponse = {
  preFolderTypologyOfFolderResponseList: FolderTypology[];
};

export enum FOLDER_TYPOLOGIES {
  BORDERC_ROSSING_RORO_EMPTY_DESCRIPTION = 'BORDERCROSSING_RORO_EMPTY_DESCRIPTION',
  BORDER_CROSSING_RORO_FULL_DESCRIPTION = 'BORDERCROSSING_RORO_FULL_DESCRIPTION',
}

export enum REGISTER_NEW_FOLDER_FORM {
  folderTypologyId = 'folderTypologyId',
  vehicleNationality = 'vehicleNationality',
  haulierGbEoriNumber = 'haulierGbEoriNumber',
  haulierEuEoriNumber = 'haulierEuEoriNumber',
  containsEmptyPackages = 'containsEmptyPackages',
  internalClientReference = 'internalClientReference',
  applicantNotificationEmail = 'applicantNotificationEmail',
}

export type RegisterNewFolderForm = {
  direction: string;
  vehicleNationality: string;
  haulierEuEoriNumber: string;
  haulierGbEoriNumber: string;
  internalClientReference: string;
  applicantNotificationEmail: string;
  containsEmptyPackages: 'true' | 'false';
  folderTypologyId: OPEN_CUSTOMS_AND_CROSSING;
};
